import React from 'react';

export default function useIsMuted() {
  const [muted, setMuted] = React.useState<boolean>(false);

  React.useEffect(() => {
    function listener(event: MessageEvent<{ type?: 'audio-stream-muted', payload: boolean }>) {
      if (event.data.type === 'audio-stream-muted') {
        setMuted(event.data.payload);
      }
    }
    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, []);

  return muted;
}
